import React from 'react';

const CleanAccessoriesPopup = props => {
  const { cleanAccessories } = props;

  const closePopup = e => {
    cleanAccessories();
    const popup = e.target.closest(`[data-popup-name="clean-accessories"]`);
    popup.classList.remove('open');
  };
  return (
    <>
      <p>Zmieniając głębokość lub szerokość szafy utracisz wybrane przez siebie akcesoria</p>
      <div className="pop-up__buttons">
        <button className="button clean-accessories__button" onClick={closePopup}>
          OK
        </button>
      </div>
    </>
  );
};
export default CleanAccessoriesPopup;
